import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { RiWhatsappFill } from "react-icons/ri";


//components
import Avatar from "react-avatar";
import { Card, Col, Row,} from "react-bootstrap"

//utils
import { colors } from "../../../../../../../theme/theme";

export const CardAccountDetail = (props: any): JSX.Element => {
    const { user } = props;
    const { t: translation } = useTranslation();

    const [removePhotoUser, setRemovePhotoUser] = useState(false);
    const [previewPhoto] = useState("");


    useEffect(() => {
        if (previewPhoto !== "" && removePhotoUser) {
            setRemovePhotoUser(false);
        }
    }, [previewPhoto])

    return (
        <Card className="card-detail">
            <Card.Body>
                <Card.Title>
                    <Row>
                        <Col sm={12} className="d-flex align-items-center">
                            <h4 className="mb-0 text-darker-grey" style={{ fontSize: '22px' }}>{translation('userAccount.account')}</h4>
                        </Col>
                    </Row>
                </Card.Title>
                <Row className="mt-3 p-0">
                    <hr />
                </Row>
                <Row>
                    <Col md={3} className={`d-flex justify-content-center align-items-center mb-3`}>
                        <Avatar
                            size="100" round={true} name={user.username !== "" ? user.username : "U S"}
                            src={
                                !removePhotoUser ? (
                                    previewPhoto !== "" ? previewPhoto : (user.picture ?? "")
                                ) : ""
                            } color={colors.mainColors.blueberry}
                        />
                    </Col>
                    <Col md={9} className="d-flex align-items-center">
                        <Row>
                            <Col xs={12} className="mb-2">
                                <h6><span className="text-darker-grey">{translation('userAccount.displayName')}:</span> { user.name ? user.name : translation('userAccount.uninformed')}</h6>
                            </Col>
                            <Col xs={12} className="mb-2">
                                <h6>
                                    <span className="text-darker-grey">{translation('userAccount.phone')}:</span> {user.phone ? user.phone : translation('userAccount.uninformed')}
                                    {
                                        user.is_whatsapp && user.phone &&
                                        <a href={`https://api.whatsapp.com/send/?phone=55${user.phone.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replaceAll("-", "")}&text&app_absent=0`} target="_blank">
                                            <RiWhatsappFill style={{ width: "20px", height: "20px", marginLeft: "5px", paddingBottom: '3px', color: "#25ca66" }} />
                                        </a>
                                    }
                                </h6>
                            </Col>
                            <Col xs={12} className="mb-2">
                                <h6><span className="text-darker-grey">{translation('userAccount.responsible')}:</span> {user.username ? user.username : translation('userAccount.uninformed')}</h6>
                            </Col>
                            <Col xs={12} className="mb-2">
                                <h6><span className="text-darker-grey">{translation('userAccount.type')}:</span> {user.status}</h6>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}